


























import Vue from "vue";
import { EXAMS } from "@tt-app/constants";
import { Exam, LevelFilterOption, SelectedLevelIndexes } from "@tt-app/models";

import TtFilterResetButton from "@tt-app/components/ui/TtFilterResetButton.vue";
import levelIcon from "@joyz/app-core/assets/icons/lightblue/Level.svg";

interface Data {
  exams: Exam[];
  levelIcon: string;
}

/**
 * --- container-selector="course-catalog-container" ----
 * When LevelFilter is used in CourseExplorer.vue
 */

interface Computed {
  exam: Exam;
  levelCounts: number[];
  levelFilterOptions: LevelFilterOption[];
  selectedLevelCount: number;
}

interface Props {
  cefrjLevelCounts: { [level: number]: number };
  examSelectionHandler: (examIndex: number) => void;
  levelSelectionHandler: (event: MouseEvent) => void;
  selectedExamIndex: number;
  selectedLevelIndexes: SelectedLevelIndexes;
}
/**
 * --- container-selector="course-catalog-container" ----
 * When LevelFilter is used in CourseExplorer.vue
 */
export default Vue.extend<Data, {}, Computed, Props>({
  name: "LevelFilter",
  components: {
    TtFilterResetButton
  },
  props: {
    cefrjLevelCounts: { type: Object, required: true },
    examSelectionHandler: { type: Function, required: true },
    levelSelectionHandler: { type: Function, required: true },
    selectedExamIndex: { type: Number, required: true },
    selectedLevelIndexes: { type: Object, required: true }
  },
  data() {
    return {
      exams: EXAMS,
      levelIcon: levelIcon
    };
  },
  computed: {
    exam() {
      return this.exams[this.selectedExamIndex];
    },
    levelCounts() {
      return this.exam.levels.map(level => {
        let count = 0;
        level.cefrjMap.forEach(index => {
          count += this.cefrjLevelCounts[index] || 0;
        });
        return count;
      });
    },
    levelFilterOptions() {
      return this.exams.map(({ name }, index) => ({
        label: name,
        value: index
      }));
    },
    selectedLevelCount() {
      return Object.values(this.selectedLevelIndexes).filter(levelStatus => {
        return levelStatus;
      }).length;
    }
  }
});
